import { Contact } from '@tamalelibs/models/contact.model';
import { EntityBack } from '../entity-dialog/entity-dialog.model';

export class ContactDialogOpenOptions {
    openType: ContactDialogType;
    minimize: boolean;
    contact: Contact;
    entityBack: EntityBack;
    eventKey?: string;
    eventValue?: string;
    instanceId = '';
}

export enum ContactDialogType {
    CreateContact = 'Create Contact',
    EditContact = 'Edit Contact',
}

export class SocialMedia {
    facebook?: string;
    linkedIn?: string;
    skype?: string;
    twitter?: string;
    other?: string;
}
